import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StatusTagContainerProps {
  color: string;
  backgroundColor: string;
}

export const StatusTagContainer = styled(Box)<StatusTagContainerProps>(
  ({ color, backgroundColor, theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(1, 3),
    borderRadius: '46px',
    color: color,
    backgroundColor: backgroundColor,
  }),
);
